
const Features = () => {
  const features = [
    {
      icon: 'ri-focus-2-line',
      title: 'Ultra-High Precision',
      description: 'Achieving tolerances down to micrometers with advanced control systems'
    },
    {
      icon: 'ri-speed-line',
      title: 'Rapid Processing',
      description: 'Optimized workflows for maximum productivity and efficiency'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Quality Assurance',
      description: 'Rigorous testing and certification for every component'
    },
    {
      icon: 'ri-global-line',
      title: 'Global Standards',
      description: 'Compliance with international manufacturing regulations'
    },
    {
      icon: 'ri-cpu-line',
      title: 'Smart Technology',
      description: 'AI-powered systems for predictive maintenance and optimization'
    },
    {
      icon: 'ri-customer-service-2-line',
      title: '24/7 Support',
      description: 'Dedicated technical support team available around the clock'
    },
  ];

  return (
    <section className="py-24 bg-[#001E3C] relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#00D9C9]/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#0066FF]/5 rounded-full blur-3xl"></div>

      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="text-[#00D9C9] text-sm font-semibold tracking-wider uppercase">Technical Excellence</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-white mt-4 mb-6">
            Why Choose Our Technology
          </h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            Industry-leading capabilities that set new standards in precision manufacturing
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group relative bg-white/5 backdrop-blur-sm border border-white/10 rounded-lg p-8 hover:bg-white/10 hover:border-[#00D9C9]/50 transition-all duration-300"
            >
              {/* Icon */}
              <div className="w-14 h-14 bg-[#00D9C9]/10 border border-[#00D9C9] rounded-lg flex items-center justify-center mb-6 group-hover:bg-[#00D9C9] group-hover:scale-110 transition-all duration-300">
                <i className={`${feature.icon} text-2xl text-[#00D9C9] group-hover:text-[#001E3C]`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl font-bold text-white mb-3 group-hover:text-[#00D9C9] transition-colors duration-300">
                {feature.title}
              </h3>
              <p className="text-white/70 leading-relaxed">
                {feature.description}
              </p>

              {/* Hover Effect Line */}
              <div className="absolute bottom-0 left-0 w-0 h-1 bg-[#00D9C9] group-hover:w-full transition-all duration-500"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
